module.exports = __webpack_public_path__ + "img/derecho-constitucional.a3e93292.svg";